import { FC, useEffect, useContext, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { format } from "date-fns";

import FooterText from "src/components/footerText";
import CaseVolume from "src/components/manufacturer/caseVolumeLineChart";
import GeographicalStatistics from "src/components/manufacturer/geographicalStatistics";
import CaseFilter from "src/components/manufacturer/statistics";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import CustomTopPayorDetail from "src/components/manufacturer/customTopPayorDetail";
import InsurancePayorDetail from "src/components/manufacturer/InsurancePayorDetail";
import CustomComponentForTransfer from "src/components/manufacturer/customComponentForTransfer";
import CustomComponentForPriorAuth from "src/components/manufacturer/customComponentPriorAuth";
import CustomComponentAreaCaseBySubmission from "src/components/manufacturer/customComponentAreaCaseBySubmission";

import useFetch from "src/hooks/useFetch";
import {AuthContext} from "../../context/authContext";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { areManFiltersUpdated, getDefaultManFilters } from "src/helpers/manufacturer";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { GeographicalStatisticsObject, StatisticsApiResponse } from "./types";
import { StatsSearchProps } from "src/components/manufacturer/statistics/types";



const Manufacturer: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData } = useContext(AuthContext);
  const [searchParams, updateSearchParams] = useSearchParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const insuranceName:string | null = params.get('insurance_name');

  const [queryParams, changeQueryParams] = useState(getDefaultManFilters(searchParams, userData, "index"));

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);


  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);


  useEffect(() => {
    if (insuranceName) {
      const updatedQueries = {
        ...queryParams,
        insurance_name:insuranceName
      }
      changeQueryParams(updatedQueries)
      getStatsData({}, {}, updatedQueries);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insuranceName]);

  const updateQueryParamsAndCallAPI = (
    updatedQueries: StatsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate()),
          "yyyy-MM-dd"
        ),
        period: "day",
        filter_type: "",
        type: "index",
        user_id: "",
        insurance_name: "",
        role: "manufacturer",
      });
    } else {
      changeQueryParams((oldQueryParams) => ({ ...updatedQueries, ...oldQueryParams }));
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = () => {
    const updatedQueries = {
      ...queryParams,

    }
    changeQueryParams(updatedQueries)
    getStatsData({}, {}, updatedQueries);
  }

  return (
    <div className="container-fluid overflow-auto">
      <AuthMaunfacturerSubHeader/>
      {statisticsData && (
        <CaseFilter
          defaultQueryParams={queryParams}
          updateQueryParams={updateQueryParamsAndCallAPI}
        />
      )}
      {statisticsData && (
        <CaseVolume StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData} buttonShows={true} />
      )}
      {statisticsData && (
        insuranceName?
          <InsurancePayorDetail  StatisticsObjectType={statisticsData.data}/>
          :
          <CustomTopPayorDetail  StatisticsObjectType={statisticsData.data}/>
      )}

      {statisticsData && (
        <CustomComponentForTransfer StatisticsObjectType={statisticsData.data} />
      )}

       {statisticsData && (
        <CustomComponentForPriorAuth StatisticsObjectType={statisticsData.data} />
      )}

      {statisticsData && (
        <CustomComponentAreaCaseBySubmission 
          StatisticsObjectType={statisticsData.data} title={'Area Managers'}
          queryParams={queryParams}
          isFilterObjUpdated={() => areManFiltersUpdated(queryParams, searchParams, userData, "index")}
        />
      )}

      {statisticsData?.data && (
        <GeographicalStatistics
          GeographicalStatisticsListType={
            statisticsData?.data
              .geographical_stats as unknown as GeographicalStatisticsObject[]
          }
        />
      )}
      <div className="mt-5 mb-4"><FooterText footerType="black" /></div>
    </div>
  );
};

export default Manufacturer;
